(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
(() => {
  const alignCurrentCollectionNavigation = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('[data-occhio-scroll-nav] ul').forEach((list) => {
      const currentLink = list.querySelector('[aria-current="page"]');
      const currentItem = currentLink ? currentLink.closest('li') : null;
      if (!currentItem || list.scrollWidth <= list.clientWidth) return;
      const listBounds = list.getBoundingClientRect();
      const itemBounds = currentItem.getBoundingClientRect();
      if (itemBounds.left >= listBounds.left && itemBounds.right <= listBounds.right) return;
      const itemCenter = itemBounds.left - listBounds.left + list.scrollLeft + itemBounds.width / 2;
      list.scrollLeft = Math.max(0, itemCenter - list.clientWidth / 2);
    });
  };
  const scheduleAlignment = () => requestAnimationFrame(alignCurrentCollectionNavigation);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAlignment, { once: true });
  } else {
    scheduleAlignment();
  }
  window.addEventListener('pageshow', scheduleAlignment);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occhio-appointments"] && !Shopify.designMode) return;
  try {
    
function setupOcchioAppointments(scope) {
  scope.querySelectorAll('[data-occhio-appointments]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const trigger = section.querySelector('[data-appointment-open]');
    const dialog = section.querySelector('[data-appointment-dialog]');
    if (trigger && dialog && typeof dialog.showModal === 'function') {
      const calendar = dialog.querySelector('[data-appointment-calendar]');
      const loading = dialog.querySelector('[data-appointment-loading]');
      let loadTimer;
      const showCalendar = () => {
        clearTimeout(loadTimer);
        loading.hidden = true;
      };
      calendar.addEventListener('load', () => {
        if (calendar.getAttribute('src')) showCalendar();
      });
      trigger.setAttribute('role', 'button');
      trigger.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (dialog.open) return;
        dialog.showModal();
        if (!calendar.getAttribute('src')) {
          loading.hidden = false;
          const calendarUrl = new URL(calendar.dataset.src);
          calendarUrl.searchParams.set('hl', document.documentElement.lang || 'it');
          calendar.src = calendarUrl.href;
          loadTimer = setTimeout(showCalendar, 12000);
        }
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === ' ') {
          event.preventDefault();
          trigger.click();
        }
      });
      dialog.querySelector('[data-appointment-close]').addEventListener('click', () => dialog.close());
      let backdropStart = false;
      dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog; });
      dialog.addEventListener('click', event => {
        if (backdropStart && event.target === dialog) dialog.close();
        backdropStart = false;
      });
      dialog.addEventListener('close', () => {
        if (window.location.hash === '#prenota') window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
        trigger.focus({preventScroll: true});
      });
      (section.closest('.shopify-section') || section).addEventListener('shopify:section:unload', () => {
        clearTimeout(loadTimer);
        if (dialog.open) dialog.close();
      });
      if (window.location.hash === '#prenota') trigger.click();
    }
    const date = section.querySelector('[data-appointment-date]');
    if (date) {
      const today = new Intl.DateTimeFormat('sv-SE', {timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date());
      date.min = today;
      const checkDate = () => {
        date.setCustomValidity('');
        if (!date.value) return;
        const day = new Date(date.value + 'T12:00:00Z').getUTCDay();
        if (date.value < today) date.setCustomValidity(section.dataset.past);
        else if (day === 0 || day === 1) date.setCustomValidity(section.dataset.closed);
      };
      date.addEventListener('input', checkDate);
      date.addEventListener('change', checkDate);
    }
    const service = section.querySelector('[data-appointment-service]');
    const requested = window.location.hash.slice(1);
    if (service && ['frames','vision'].includes(requested)) {
      const option = Array.from(service.options).find(item => item.dataset.service === requested);
      if (option) service.value = option.value;
    }
  });
}
setupOcchioAppointments(document);
document.addEventListener('shopify:section:load', event => setupOcchioAppointments(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occhio-brands-editorial"] && !Shopify.designMode) return;
  try {
    
function initOcchioBrands(){document.querySelectorAll('[data-occhio-brands]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const input=root.querySelector('[data-brand-search]');const cards=[...root.querySelectorAll('[data-brand-name]')];const empty=root.querySelector('[data-brand-empty]');const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();input.addEventListener('input',()=>{const query=norm(input.value.trim());let visible=0;cards.forEach(card=>{card.hidden=!norm(card.dataset.brandName).includes(query);if(!card.hidden)visible++;});empty.hidden=visible>0;});});}initOcchioBrands();document.addEventListener('shopify:section:load',initOcchioBrands);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occhio-fit-guide"] && !Shopify.designMode) return;
  try {
    
function setupOcchioFitGuide(scope) {
  scope.querySelectorAll('[data-occhio-fit]').forEach(guide => {
    if (guide.dataset.ready) return;
    const tabs = Array.from(guide.querySelectorAll('[data-fit-tab]'));
    const panels = Array.from(guide.querySelectorAll('[data-fit-panel]'));
    if (!tabs.length || panels.length !== tabs.length) return;
    const activate = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(next, true);
      });
    });
    activate(0);
    guide.querySelector('[data-fit-controls]').hidden = false;
    const trigger = guide.querySelector('[data-fit-quiz-open]');
    const dialog = guide.querySelector('[data-fit-quiz-dialog]');
    if (trigger && dialog && typeof dialog.showModal === 'function') {
      trigger.setAttribute('role', 'button');
      trigger.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (dialog.open) return;
        if (!dialog.dataset.loaded) {
          dialog.querySelector('[data-fit-quiz-mount]').append(guide.querySelector('[data-fit-quiz-template]').content.cloneNode(true));
          dialog.dataset.loaded = 'true';
        }
        dialog.showModal();
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); trigger.click(); }
      });
      dialog.querySelector('[data-fit-quiz-close]').addEventListener('click', () => dialog.close());
      let backdropStart = false;
      dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog; });
      dialog.addEventListener('click', event => {
        if (backdropStart && event.target === dialog) dialog.close();
        backdropStart = false;
      });
      dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
      (guide.closest('.shopify-section') || guide).addEventListener('shopify:section:unload', () => {
        if (dialog.open) dialog.close();
      });
    }
    guide.dataset.ready = 'true';
  });
}
setupOcchioFitGuide(document);
document.addEventListener('shopify:section:load', event => setupOcchioFitGuide(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occhio-lens-collection"]) return;
  try {
    
  async function occhioLensInit(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-lens-grid]');
    const color = root.querySelector('[data-lens-select]');
    const brand = root.querySelector('[data-brand-select]');
    const sort = root.querySelector('[data-lens-sort]');
    const stock = root.querySelector('[data-lens-stock]');
    const status = root.querySelector('[data-lens-status]');
    const pager = root.querySelector('[data-lens-pages]');
    function prepareHoverImages() {
      root.querySelectorAll('.occhio-lens-secondary-image').forEach(img => {
        if (img.dataset.hoverReady) return;
        img.dataset.hoverReady = 'true';
        const reveal = () => { if (img.naturalWidth > 0) img.classList.add('is-loaded'); };
        if (img.complete) reveal();
        else img.addEventListener('load', reveal, {once:true});
      });
    }
    prepareHoverImages();
    let page = 1;
    try {
      let next = grid.dataset.next;
      const seen = new Set();
      while (next) {
        const url = new URL(next, location.href);
        url.searchParams.set('view', 'lenti');
        if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid pagination');
        seen.add(url.href);
        const response = await fetch(url.href);
        if (!response.ok) throw new Error('Catalog unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const more = doc.querySelector('[data-lens-grid]');
        if (!more) throw new Error('Missing catalog');
        grid.append(...more.querySelectorAll('[data-lens-card]'));
        prepareHoverImages();
        next = more.dataset.next;
      }
      const cards = [...grid.querySelectorAll('[data-lens-card]')];
      const colors = new Map();
      const brands = new Set();
      cards.forEach(card => {
        if (card.dataset.color && !['trasparenti', 'trasparente'].includes(card.dataset.color)) colors.set(card.dataset.color, card.dataset.label);
        if (card.dataset.brand) brands.add(card.dataset.brand);
      });
      [...colors].sort((a,b) => a[1].localeCompare(b[1])).forEach(([value,label]) => color.add(new Option(label,value)));
      [...brands].sort((a,b) => a.localeCompare(b)).forEach(value => brand.add(new Option(value,value)));
      const readHash = () => { let value = location.hash.slice(1); if (['black','nero','nere','neri'].includes(value)) { value = 'grigio'; history.replaceState(null,'',location.pathname+location.search+'#grigio'); } color.value = colors.has(value) ? value : ''; };
      readHash();
      function render() {
        let matches = cards.filter(card => (!color.value || card.dataset.color === color.value) && (!brand.value || card.dataset.brand === brand.value) && (!stock.checked || card.dataset.stock === 'true'));
        if (sort.value !== 'default') matches.sort((a,b) => sort.value === 'asc' ? Number(a.dataset.price)-Number(b.dataset.price) : Number(b.dataset.price)-Number(a.dataset.price));
        const pages = Math.max(1,Math.ceil(matches.length/24));
        page = Math.min(page,pages);
        cards.forEach(card => { card.hidden = true; });
        matches.slice((page-1)*24,page*24).forEach(card => { card.hidden = false; grid.append(card); });
        status.textContent = matches.length ? root.dataset.countLabel.replace('[count]',String(matches.length)) : root.dataset.emptyLabel;
        pager.hidden = pages <= 1;
        root.querySelector('[data-lens-page]').textContent = `${page} / ${pages}`;
        root.querySelector('[data-lens-prev]').disabled = page === 1;
        root.querySelector('[data-lens-next]').disabled = page === pages;
      }
      [color,brand,sort,stock].forEach(control => {
        control.disabled = false;
        control.addEventListener('change',() => { page = 1; if (control === color) history.replaceState(null,'',location.pathname+location.search+(color.value ? '#'+color.value : '')); render(); });
      });
      window.addEventListener('hashchange',() => {readHash();page=1;render();});
      root.querySelector('[data-lens-prev]').addEventListener('click',() => {page--;render();status.scrollIntoView({block:'center'});});
      root.querySelector('[data-lens-next]').addEventListener('click',() => {page++;render();status.scrollIntoView({block:'center'});});
      render();
    } catch(error) {
      status.textContent = '';
      root.querySelector('[data-lens-error]').hidden = false;
    }
  }
  document.querySelectorAll('[data-lens-catalog]').forEach(occhioLensInit);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-lens-catalog]').forEach(occhioLensInit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occhio-shipping-bar"]) return;
  try {
    
if (!customElements.get('occhio-shipping-announcement')) {
  customElements.define('occhio-shipping-announcement', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('.occhio-shipping-bar__toggle');
      if (!button || this.dataset.ready) return;
      this.dataset.ready = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
